module.exports = __webpack_public_path__ + "static/media/addlogo.7b01492a.svg";